<template>
  <b-media tag="li">
    <div class="text-left">
      <p v-if="languages && (languages.length !== 0)">
        <strong>Languages</strong>: {{ defineLanguages(languages) }}.
      </p>
      <p v-else><strong>Languages</strong>: No languages have been specified</p>
    </div>
  </b-media>
</template>

<script>
export default {
  name: 'RecipeLanguage',
  props: {
    index: Number,
    languages: Array
  },
  methods: {
    defineLanguages (languages) {
      if( languages && ( languages.length > 0)) {
        if (languages.includes('Other') && languages.length !== 1) {
          let index = languages.indexOf('Other')
          languages.splice(index, 1)
        }
        return languages.join(', ')
      } else {
        return ''
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/recipes/RecipeLanguage.vue